/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Marketing_App_Anna_Quote_BoldInputs */

const en_marketing_app_anna_quote_bold = /** @type {(inputs: Marketing_App_Anna_Quote_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`this one was amazing!`)
};

const es_marketing_app_anna_quote_bold = /** @type {(inputs: Marketing_App_Anna_Quote_BoldInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¡esta fue increíble!`)
};

/**
* | output |
* | --- |
* | "this one was amazing!" |
*
* @param {Marketing_App_Anna_Quote_BoldInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const marketing_app_anna_quote_bold = /** @type {((inputs?: Marketing_App_Anna_Quote_BoldInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Marketing_App_Anna_Quote_BoldInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_marketing_app_anna_quote_bold(inputs)
	return en_marketing_app_anna_quote_bold(inputs)
});